import { makeStyles } from '@mui/styles';
import { Colors } from './colors';

export const useTextStyles = makeStyles(() => ({
  h1: {
    fontSize: '22px',
    fontWeight: 500,
    letterSpacing: 0.4,
    color: 'white'
  },
  h2: {
    fontSize: '17px',
    fontWeight: 500,
    color: 'black'
  },
  h3: {
    fontSize: '13px',
    fontWeight: 500,
    color: 'black'
  },

  dropdownMenu: {
    fontSize: '12px',
    fontWeight: 400
  },

  body: {
    fontSize: '12px',
    fontWeight: 400,
    color: Colors.extraDarkGray
  },
  note: {
    fontSize: '14px',
    fontWeight: 300,
    color: 'black'
  },
  noteDetails: {
    fontSize: '13px',
    fontWeight: 300,
    color: Colors.midDarkGray
  },
  checkboxLabel: {
    fontSize: 14,
    color: Colors.extraDarkGray
  }
}));
